import {
  Share2,
  Search,
  TrendingUp,
  Video,
  FileText,
  Briefcase,
  Globe,
  Target,
} from 'lucide-react';

const Services = () => {
  const services = [
    {
      icon: Share2,
      title: 'Social Media Management',
      description:
        'Complete social media management across all platforms. Content creation, scheduling, community engagement, and growth strategies.',
      image: 'https://images.unsplash.com/photo-1611162617213-7d7a39e9b1d7',
    },
    {
      icon: Search,
      title: 'Google Ads Campaigns',
      description:
        'High-ROI Google Ads campaigns with precise targeting, keyword optimization, and conversion tracking to maximize your ad spend.',
      image: 'https://images.unsplash.com/photo-1551288049-bebda4e38f71',
    },
    {
      icon: TrendingUp,
      title: 'Lead Generation',
      description: 'Proven lead generation strategies for real estate, healthcare, and B2B. We have generated 10,000+ qualified leads across NCR.',
      image: 'https://images.unsplash.com/photo-1460925895917-afdab827c52f',
    },
    {
      icon: Video,
      title: 'Creative Reels & Videos',
      description:
        'Viral-ready Instagram Reels, YouTube Shorts, and video content that captures attention and drives engagement.',
      image: 'https://images.unsplash.com/photo-1492619375914-88005aa9e8fb',
    },
    {
      icon: FileText,
      title: 'Content Marketing',
      description:
        'Engaging content that educates, entertains, and converts. Blog posts, social content, email campaigns, and more.',
      image: 'https://images.unsplash.com/photo-1557200134-90327ee9fafa',
    },
    {
      icon: Briefcase,
      title: 'Business Development',
      description:
        'Strategic business development programs and roadmaps to scale your business with sustainable growth strategies.',
      image: 'https://images.unsplash.com/photo-1542744173-8e7e53415bb0',
    },
    {
      icon: Globe,
      title: 'Website Building & Management',
      description:
        'Professional website design, development, and ongoing management. Fast, beautiful, and conversion-optimized.',
      image: 'https://images.unsplash.com/photo-1467232004584-a241de8bcf5d',
    },
    {
      icon: Target,
      title: 'Meta Ads (Facebook & Instagram)',
      description:
        'Targeted Facebook and Instagram advertising campaigns that reach your ideal customers and drive conversions.',
      image: 'https://images.pexels.com/photos/7947754/pexels-photo-7947754.jpeg',
    },
  ];

  return (
    <section id="services" className="py-24 md:py-32 bg-white" data-testid="services-section">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <span className="text-xs font-bold uppercase tracking-[0.2em] text-teal-600 mb-4 block">
            Our Services
          </span>
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold tracking-tight text-slate-900 mb-6">
            Everything You Need to Grow Online
          </h2>
          <p className="text-lg text-slate-600 max-w-2xl mx-auto">
            From strategy to execution, we provide comprehensive digital marketing solutions that deliver results.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6" data-testid="services-grid">
          {services.map((service) => {
            const Icon = service.icon;
            return (
              <div
                key={service.title}
                className="group bg-white border border-slate-200 rounded-2xl overflow-hidden shadow-sm hover:shadow-xl transition-all duration-300 hover:-translate-y-1"
                data-testid={`service-card-${service.title.replace(/\s+/g, '-').toLowerCase()}`}
              >
                <div className="relative h-48 overflow-hidden">
                  <img
                    src={service.image}
                    alt={service.title}
                    className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-500"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-slate-900/60 to-transparent"></div>
                  <div className="absolute bottom-4 left-4">
                    <div className="w-12 h-12 bg-teal-500 rounded-xl flex items-center justify-center shadow-lg">
                      <Icon className="w-6 h-6 text-white" />
                    </div>
                  </div>
                </div>
                <div className="p-6">
                  <h3 className="text-xl font-semibold text-slate-900 mb-3">{service.title}</h3>
                  <p className="text-slate-600 leading-relaxed">{service.description}</p>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default Services;